<template>
  <div class="app-shell">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>
